module.exports = __webpack_public_path__ + "static/media/hilo-light.5008b09f.svg";